import { Col } from 'react-bootstrap';
import { AuthenticateForm } from '../auth/AuthenticationModal';

export default function ClaimGuestLogin() {
  return (
    <Col xs={12} md={12} lg={8} className="mx-auto">
      <div className="text-block pb-4">
        <h5>Log in or sign up to accept</h5>
        <p className="text-sm text-muted">It just takes a few seconds.</p>
        <AuthenticateForm
          onSuccess={() =>
            window?.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth',
            })
          }
        />
      </div>
    </Col>
  );
}
